export const normalizeFile = (e: any) => {
  if (Array.isArray(e)) {
    return e
  }
  return e?.fileList
}